// node_modules
import React, { useState, useEffect, useRef } from "react";
import {useDispatch} from 'react-redux'
import { useParams } from "react-router-dom";
import {useCurrentOrders} from '../../hooks/useCurrentOrders'

// redux
import {setTimezone} from '../../redux/slices/app.slice'

// components
import Footer from "../../components/Footer";

// styles
import * as styles from "./StatusScreen.module.css";

const StatusScreen = () => {
  const dispatch = useDispatch();
  const statusWS = useRef(null);

  const { stationId } = useParams();

  const [ordersInProgress, setOrdersInProgress] = useState();
  const [isExist, setIsExist] = useState(true);
  const [isClosed, setIsClosed] = useState(false);
  const [stationName, setStationName] = useState(null);
  const pingIntervalId = useRef(null);
  const { orders: ordersDone, setValue: setOrdersDone } = useCurrentOrders();

  useEffect(() => {
    let baseUrl = process.env.BACKEND_URL;
    baseUrl = baseUrl.replace("api", "ws");
    baseUrl = baseUrl.replace("https", "wss");
    baseUrl = baseUrl.replace("http", "ws");
    statusWS.current = new WebSocket(`${baseUrl}`);

    statusWS.current.addEventListener("open", () => {
      statusWS.current.send(
        JSON.stringify({
          type: "timezone",
        })
      );
      statusWS.current.send(JSON.stringify({ type: "stations-orders" }));

      clearInterval(pingIntervalId.current);
      pingIntervalId.current = setInterval(() => {
        try {
          statusWS.current.send(JSON.stringify({ type: "ping" }));
        } catch (e) {
          console.warn("⚠️ Ping failed:", e);
        }
      }, 55 * 1000);
    });

    statusWS.current.addEventListener("message", (event) => {
      const data = JSON.parse(event.data);
      
      if(data.type === 'timezone') {
        dispatch(setTimezone(data.data.timezone));
      }
      
      if (data.type === "stations-orders") {
        const station = data.data.find((item) => item.id === +stationId);

        if (!station) {
          setIsExist(false);
        } else {
          setStationName(station.name);
          setIsClosed(!!station.isClosed);
          console.log(station);
          const readyOrders = station.orders.filter(
            (order) => order.status === 1
          );
          const inProgressOrders = station.orders.filter(
            (order) => order.status === 0
          );
          setOrdersDone(readyOrders);
          console.log(readyOrders);
          setOrdersInProgress(inProgressOrders);
        }
      }
    });
    
    statusWS.current.addEventListener("close", () => {
      clearInterval(pingIntervalId.current);
    });

    return () => {
      statusWS.current.close();
    };
  }, []);

  return (
    <div className={styles.pageWrapper}>
      {isExist ? (
        <>
          <h1>
            {stationName} {isClosed && "CLOSED"}
          </h1>
          <div className={styles.columnsWrapper}>
            <div className={styles.columnInProgress}>
              <div className={styles.columnHeader}>IN PROCESS</div>
              <div className={styles.orders}>
                {!!ordersInProgress?.length &&
                  ordersInProgress.map((order) => {
                    return (
                      <div className={styles.orderNumber}>{order.number}</div>
                    );
                  })}
              </div>
            </div>
            <div className={styles.columnReady}>
              <div className={styles.columnHeader}>READY TO PICK UP</div>
              <div className={styles.orders}>
                {!!ordersDone?.length &&
                  ordersDone.map((order) => {
                    return (
                      <div className={styles.orderNumber}>{order.number}</div>
                    );
                  })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>STATION DO NOT EXIST</div>
      )}
      <Footer />
    </div>
  );
};

export default StatusScreen;
